import ImagesModel from "../../../Global/Models/Images/ImagesModel";
import RelatedEntityRelationship from "../../../Global/Models/Related/RelatedEntityRelationship";
import { GameStatusEnum } from "../../TopX/Enums/GameStatusEnum";
import EventGameFixturesModel from "./EventGameFixturesModel";
import EventGameTiebreakerModel from "./EventGameTiebreakerModel";

export default class EventGameModel {
  public id: string = null;
  public title: string = null;
  public description: string | null = null;
  public images: ImagesModel | null = null;
  public rules: string | null = null;
  public customFields: Record<string, string> | null = null;
  public type: string = "EVENT";
  public status: GameStatusEnum = null;
  public related: RelatedEntityRelationship[] = [];
  public tiebreaker: EventGameTiebreakerModel | null = null;
  public predictionsCutoff: string | null = null;
  public fixtures: EventGameFixturesModel[] = [];
  public createdAt: string = null;
  public updatedAt: string = null;
}
